import React from "react";
import { CalendarX, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
export default function EventsDisplay() {
  return <section id="eventsdisplay" className="bg-[var(--color-dark-bg)] py-20 md:py-32 px-4 sm:px-6 lg:px-8 min-h-[60vh] flex flex-col justify-center">
      <div className="max-w-3xl mx-auto w-full">
        {}
        <div className="text-center mb-12">
          <h2 className="font-serif text-5xl md:text-7xl text-white tracking-wide mb-4 uppercase">
            Events at Sultani
          </h2>
          <p className="font-default text-gray-400 text-lg md:text-xl max-w-2xl mx-auto">
            Join us for special nights, exclusive tastings, and community gatherings in Irving.
          </p>
        </div>

        {}
        <Card className="bg-transparent border border-gray-800/60 shadow-none rounded-2xl p-8 md:p-16 text-center">
          <CardContent className="flex flex-col items-center justify-center p-0">
            <div className="w-20 h-20 rounded-full bg-gray-900/50 flex items-center justify-center mb-8 border border-gray-800/80">
              <CalendarX className="w-10 h-10 text-gray-600" strokeWidth={1.5} />
            </div>
            
            <h3 className="font-serif text-3xl md:text-4xl text-white mb-4 tracking-wide uppercase">
              No Upcoming Events
            </h3>
            
            <p className="font-default text-gray-400 mb-10 max-w-md mx-auto leading-relaxed text-base md:text-lg">
              We're currently cooking up some exciting new events. Check back soon or follow us on Instagram for the latest updates and announcements!
            </p>
            
            <Button asChild className="bg-[var(--color-fire-orange)] text-white hover:bg-[#b34100] transition-colors duration-300 rounded-full px-8 py-6 h-auto font-default text-base md:text-lg font-semibold shadow-lg shadow-[var(--color-fire-orange)]/20 border-none">
              <Link to="https://instagram.com/sultanigrill" newTab>
                <Instagram className="w-5 h-5 mr-2" />
                Follow @sultanigrill
              </Link>
            </Button>
          </CardContent>
        </Card>

        {}
        <div className="mt-16 text-center">
          <p className="font-default italic text-gray-500 text-sm md:text-base tracking-wide">
            Private catering available for your special occasions.
          </p>
        </div>
      </div>
    </section>;
}